import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { IDietaryHabitsDetailed } from 'src/app/interfaces/SocialHistory/DietaryHabits/IDietaryHabitsDetailed';
import { DietaryHabitsService } from 'src/app/services/dietaryHabits.service';
import { PermissionService } from 'src/app/services/permission.service';
import { SwalToastService } from 'src/app/services/swal.service';
import Swal from 'sweetalert2';
import { DietaryHabitsAddEditComponent } from './dietary-habits-add-edit/dietary-habits-add-edit.component';

@Component({
  selector: 'app-dietary-habits',
  templateUrl: './dietary-habits.component.html',
  styleUrls: ['./dietary-habits.component.css'],
  standalone: false,
})
export class DietaryHabitsComponent implements OnInit {
  public addComp = DietaryHabitsAddEditComponent;
  private destroy$ = new Subject<void>();
  dietaryHabits?: IDietaryHabitsDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly dietaryHabitsService: DietaryHabitsService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: IDietaryHabitsDetailed) {
    this.dietaryHabitsService.dietaryHabitsModalSub.next(true);
    this.dietaryHabitsService.dietaryHabitsEditSub.next(item ?? null);
  }
  deleteFun(dietaryHabitsId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder3'
      )} ${this.translate.instant('Dietary Habits')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.dietaryHabitsService
          .deleteDietaryHabits(dietaryHabitsId)
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Dietary Habits deleted successfully'
              );
              this.dietaryHabitsService.deleteDietaryHabits(dietaryHabitsId);
              this.dietaryHabitsService.getData();
            },
            error: (err) => {
              this.swalToastService.toastError(
                'Unable to delete Dietary Habits'
              );
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Dietary Habits is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }

  ngOnInit() {
    this.dietaryHabitsService.dietaryHabitsLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.dietaryHabitsService.dietaryHabitsDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IDietaryHabitsDetailed[]) => {
        this.dietaryHabits = data;
      });

    this.dietaryHabitsService.getData();
  }
}
